import { Link } from 'react-router-dom';

const sectionStyle = { marginTop: 28 };
const h2Style = { fontSize: 20, fontWeight: 700, marginBottom: 10 };
const pStyle = { color: '#374151', lineHeight: 1.7, fontSize: 14, marginBottom: 10 };
const liStyle = { color: '#374151', lineHeight: 1.7, fontSize: 14, marginBottom: 6 };

export default function PrivacyPolicyPage() {
  return (
    <div className="fade-up" style={{ maxWidth: 760, margin: '0 auto', padding: '40px 20px' }}>
      <Link to="/" style={{ fontSize: 12, color: '#6B7280', textDecoration: 'none' }}>← Back to Sungresh</Link>
      <h1 style={{ fontSize: 32, fontWeight: 800, marginTop: 16, marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: '#6B7280', fontSize: 13, marginBottom: 24 }}>Last updated: September 14, 2026</p>

      <p style={pStyle}>
        Sungresh ("we," "us," or "our") operates the sungresh.com website and platform
        (the "Service"). This page explains what information we collect, how we use it,
        and the choices you have. By using the Service, you agree to the collection and
        use of information in accordance with this policy.
      </p>

      <div style={sectionStyle}>
        <div style={h2Style}>Information We Collect</div>
        <p style={pStyle}><strong>Account information.</strong> When you register, we collect your name, email address, and password (stored securely and never in plain text via our authentication provider, Supabase).</p>
        <p style={pStyle}><strong>Usage data.</strong> We record which tools you use, the domains/keywords you search, and your credit balance and history, so the Service can function and so we can improve it.</p>
        <p style={pStyle}><strong>Content you submit.</strong> Text you paste into the AI Checker, Content Writer, or similar tools is sent to our AI provider (Anthropic) to generate a response. We do not use this content to train any AI model.</p>
        <p style={pStyle}><strong>Cookies and similar technologies.</strong> We use essential cookies to keep you logged in. If we run advertising (including Google AdSense) on the Service, Google and its partners may use cookies to serve ads based on your visits to this and other sites — see the "Advertising" section below.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>How We Use Your Information</div>
        <ul style={{ paddingLeft: 20 }}>
          <li style={liStyle}>To provide, operate, and maintain the Service</li>
          <li style={liStyle}>To process the specific tool request you make (e.g., a keyword lookup or content generation)</li>
          <li style={liStyle}>To manage your account, credits, and subscription plan</li>
          <li style={liStyle}>To detect, prevent, and address technical issues or abuse</li>
          <li style={liStyle}>To send you service-related communications (e.g., trial expiration notices)</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>Third-Party Services We Use</div>
        <p style={pStyle}>We rely on the following third-party providers to operate the Service. Each has its own privacy policy governing how they handle data:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li style={liStyle}><strong>Supabase</strong> — authentication and database hosting</li>
          <li style={liStyle}><strong>Anthropic (Claude API)</strong> — powers our AI Content Writer and AI Checker tools</li>
          <li style={liStyle}><strong>DataForSEO</strong> — supplies keyword, domain, and backlink data</li>
          <li style={liStyle}><strong>Hostinger</strong> — hosts our application infrastructure</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>Advertising</div>
        <p style={pStyle}>
          If Sungresh displays advertisements through Google AdSense or similar networks, those
          third parties may use cookies to serve ads based on your prior visits to this and other
          websites. You can opt out of personalized advertising by visiting{' '}
          <a href="https://adssettings.google.com" style={{ color: '#FF642D' }}>Google's Ads Settings</a>.
        </p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>Data Retention</div>
        <p style={pStyle}>We retain your account data for as long as your account is active. You can request deletion of your account and associated data at any time by contacting us (see below).</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>Your Rights</div>
        <p style={pStyle}>Depending on your location, you may have the right to access, correct, export, or delete your personal data. To exercise these rights, contact us using the details below.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>Children's Privacy</div>
        <p style={pStyle}>The Service is not directed to individuals under 16. We do not knowingly collect personal information from children.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>Changes to This Policy</div>
        <p style={pStyle}>We may update this Privacy Policy from time to time. We will post any changes on this page and update the "Last updated" date above.</p>
      </div>

      <div style={sectionStyle}>
        <div style={h2Style}>Contact Us</div>
        <p style={pStyle}>Questions about this policy? Contact us at <a href="mailto:privacy@sungresh.com" style={{ color: '#FF642D' }}>privacy@sungresh.com</a>.</p>
      </div>
    </div>
  );
}
